function initHeroSplide() {
  const heroSliders = document.querySelectorAll('.hero-slider_wrapper');

  heroSliders.forEach((el) => {
    if (el.splideInstance) {
      el.splideInstance.destroy(true);
    }

    const isAutoplay = el.dataset.autoplay === 'true';
    const slideSpeed = parseInt(el.dataset.speed, 10) || 5;

    const desktopPerPage = parseInt(el.dataset.desktopPerPage, 10) || 1;
    const desktopPerMove = parseInt(el.dataset.desktopPerMove, 10) || 1;

    const mobilePerPage = parseInt(el.dataset.mobilePerPage, 10) || 1;
    const mobilePerMove = parseInt(el.dataset.mobilePerMove, 10) || 1;

    const desktopGap = `${parseInt(el.dataset.desktopGap || 0, 10)}px`;
    const mobileGap = `${parseInt(el.dataset.mobileGap || 0, 10)}px`;

    const splide = new Splide(el, {
      type: 'loop',

      perPage: desktopPerPage,
      perMove: desktopPerMove,
      gap: desktopGap,
      drag: true,
      arrows: true,
      pagination: false,

      autoplay: isAutoplay,
      interval: slideSpeed * 1000,
      speed: 800,

      pauseOnHover: false,
      pauseOnFocus: false,
      resetProgress: false,

      breakpoints: {
        749: {
          perPage: mobilePerPage,
          perMove: mobilePerMove,
          gap: mobileGap,
          pagination: false,
          focus: 'center',
        },
      },
    });

    splide.on('mounted move', function () {
      const prevArrow = el.querySelector('.splide__arrow--prev');
      const nextArrow = el.querySelector('.splide__arrow--next');

      if (!prevArrow || !nextArrow) return;

      const current = splide.index;
      const last = splide.length - 1;

      prevArrow.classList.remove('is-inactive');
      nextArrow.classList.remove('is-inactive');

      if (current === 0) {
        prevArrow.classList.add('is-inactive');
      }

      if (current === last) {
        nextArrow.classList.add('is-inactive');
      }
    });

    splide.mount();

    el.splideInstance = splide;
  });
}

document.addEventListener('DOMContentLoaded', initHeroSplide);

document.addEventListener('shopify:section:load', function (event) {
  if (event.target.querySelector('.hero-slider_wrapper')) {
    initHeroSplide();
  }
});